var _path, _path2, _path3, _path4, _path5, _rect;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgFitnessClasses = function SvgFitnessClasses(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2365 10.6055H8.86066C8.5795 10.6055 8.35156 10.8334 8.35156 11.1146V18.5814C8.35156 18.8626 8.5795 19.0905 8.86066 19.0905H11.2365C11.5176 19.0905 11.7456 18.8626 11.7456 18.5814V11.1146C11.7456 10.8334 11.5176 10.6055 11.2365 10.6055Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.424 10.6055H19.0482C18.767 10.6055 18.5391 10.8334 18.5391 11.1146V18.5814C18.5391 18.8626 18.767 19.0905 19.0482 19.0905H21.424C21.7052 19.0905 21.9331 18.8626 21.9331 18.5814V11.1146C21.9331 10.8334 21.7052 10.6055 21.424 10.6055Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8125 16.8827V12.8099C5.8125 12.5287 6.04043 12.3008 6.3216 12.3008H7.84891C8.13008 12.3008 8.35801 12.5287 8.35801 12.8099V16.8827C8.35801 17.1639 8.13008 17.3918 7.84891 17.3918H6.3216C6.04043 17.3918 5.8125 17.1639 5.8125 16.8827Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4752 16.8827V12.8099C24.4752 12.5287 24.2473 12.3008 23.9661 12.3008H22.4388C22.1576 12.3008 21.9297 12.5287 21.9297 12.8099V16.8827C21.9297 17.1639 22.1576 17.3918 22.4388 17.3918H23.9661C24.2473 17.3918 24.4752 17.1639 24.4752 16.8827Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 14.8477H18.538",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    width: 21.2132,
    height: 21.2132,
    rx: 3,
    transform: "rotate(45 15 0)",
    stroke: "white",
    strokeWidth: 1.5
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFitnessClasses, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/FitnessClasses.54443e88.svg";
export { ForwardRef as ReactComponent };